<template>
  <div v-if="homeData">
    <Header  :homeData="homeData"></Header>
    <BenefitsOrthodontics ></BenefitsOrthodontics>
    <StepsJob></StepsJob>
    <PhotosGallery :data="homeData"></PhotosGallery>
    <Questions :data="homeData"></Questions>
    <Partners :provinces="homeData.provincesWithDoctors" :data="homeData.settings"></Partners>
    <WeblogsSection v-if="homeData.posts.length>0" :data="homeData.posts"></WeblogsSection>
<!--    <Footer></Footer>-->
<!--    <FooterResp class="d-md-none"></FooterResp>-->
  </div>
    <loader v-else />
</template>

<script>
 import loader from "@/components/loader.vue" 
import Header from "../components/Header";
import BenefitsOrthodontics from "../components/BenefitsOrthodontics";
import StepsJob from "../components/StepsJob";
import PhotosGallery from "../components/PhotosGallery";
import Questions from "../components/Questions";
import Partners from "../components/Partners";
import WeblogsSection from "../components/WeblogsSection";
// import Footer from "../components/Footer";
// import FooterResp from "../components/FooterResp";
export default {
  name: "Home",
  components:{
    Header,loader,
    BenefitsOrthodontics,
    StepsJob,
    PhotosGallery,
    Questions,
    Partners,
    WeblogsSection,
    // Footer,
  },
  computed:{
    homeData(){
      return this.$root.homeData
    }
  },
  
     metaInfo() {
    return {
      title:this.homeData?this.homeData.settings.site_title:"صفحه اصلی",
      meta: [
        {
          name: "description",
          content:"وبسایت دکتر صادقی فوق تخصص جراحی دندان و اولین ایرانی تولید کننده ارتودنسی های نامرئی"
        },
      ]
    };
  },
}
</script>

<style scoped>

</style>